export default __webpack_public_path__ + "static/media/template8.96148506.jpg";